import './Administracion.css'
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { GestionarBancos } from './modalRegistrarBancos';

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';
import useTable from '../useTable';
import { Toasts } from '../toasts';

import { PrimaryButton } from '../../ui/buttons/Button';
import op from '../../modulos/datos';

const BancoRow = ({ item, permisoStr, gestionarBanco }) => (
    <tr style={{ padding: "0" }}>
        <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.idbanco}</td>
        <td className='align-baseline' style={{ textAlign: "left", alignItems: 'center', width: 'auto' }}>{item.nombre}</td>

        <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', maxWidth: '60px' }}>
            <button
                onClick={gestionarBanco(4, item.idbanco, permisoStr[0])}
                className={permisoStr[0] === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
            >
                <i className="fas fa-eye"></i>
            </button>
            <a> &nbsp; </a>
            <button
                onClick={gestionarBanco(2, item.idbanco, permisoStr[2])}
                className={permisoStr[2] === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
            >
                <i className="fa fa-edit"></i>
            </button>
            <a> &nbsp; </a>
            <button
                onClick={gestionarBanco(3, item.idbanco, permisoStr[3])}
                className={permisoStr[3] === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
            >
                <i className="fa fa-trash-alt"></i>
            </button>
        </td>
    </tr>
);

const TablaBancos = (props) => {
    const token = localStorage.getItem('jwtToken');
    const headCells = [
        { id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
        { id: 'descripcion', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center', width  : '60px' },
    ]
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(1);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accbanco'))
    const permisoStr = (permiso ?? '').toString();
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [bancos, setBancos] = useState()

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        const { value } = e.target;
        setFilterFn({
            fn: items => {
                if (!value) return items;

                const search = value.toLowerCase();

                return items.filter(x =>
                    (x.idbanco && x.idbanco.includes(value)) ||
                    (x.nombre && x.nombre.toLowerCase().includes(search))
                );
            }
        })

    }

    const seleccionarRegistros = () => {
        let campos =
            "*";
        let nomtab = "bancos";
        let orden = "idbanco";

        let endpoint =
            op.conexion +
            `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setRecords(response.data);
                }
            })
            .catch(function (error) {
                const texto = error?.response?.data?.message || 'Error al consultar bancos';
                setMensaje({ mostrar: true, titulo: 'Error', texto, icono: 'error' });
            })
            .finally(() => {
                setActivate(false);
            });
    };
    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }
    const seleccionarBanco = (id) => {
        let campos = "*"
        let nomtab = "bancos";
        let nomid = "idbanco";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.idbanco !== '') {
                    setBancos(response.data)
                    setMostrar2(true)
                    setActivate(false);
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const cerrarModal = () => {
        setMostrar2(false)
    }
    const gestionarBanco = (op, id, per) => (e) => {
        e.preventDefault();
        if (per.toString() === '1') {
            setOperacion(op)
            if (op === 1) {
                setMostrar2(true)
            } else {
                seleccionarBanco(id);
            }
        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }
    return (
        <section className='col-7 m-0 p-0 mt-5 mx-auto'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>
                    Gestion de Bancos
                </h3>
                <a type='button' onClick={cerrar}>
                    salir<i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e)=>{e.preventDefault()}} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <input type="text" 
                        ref={txtBuscador} 
                        onChange={handleSearch} 
                        placeholder="Buscar"
                        className='search-input form-control form-control-sm' />
                </div>
                <PrimaryButton icon = 'fa-plus m-0'
                    disabled={permisoStr[1] !== '1'}
                    onClick={gestionarBanco(1, '', permisoStr[1])} 
                    title='Agregar Contribuyente' 
                >
                </PrimaryButton>
            </form>
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item) => (
                                <BancoRow
                                    key={item.idbanco}
                                    item={item}
                                    permisoStr={permisoStr}
                                    gestionarBanco={gestionarBanco}
                                />
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <GestionarBancos
                show={mostrar2}
                onHideCancela={cerrarModal}
                operacion={operacion}
                bancos={bancos}
                onHideRenderizar={seleccionarRegistros}/>
            <Dimmer active={activate} inverted></Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}/>
        </section>
    );
}
export default TablaBancos;